export default[
    {
        path: '/cessao/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro da cessa do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/cessao/trabalhador/lista',
        name: 'lista da cessa do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/cessao/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar cessa do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]